import React, { useState, useEffect } from 'react'
import Layout from '../Layout'
import DashboardHeader from '../DashboardHeader'
import CartComponent from '../../../utils/CommonFunctionality/Cart'
import SEOTAG from '../../../utils/CommonFunctionality/SEO/AllpagesSEO'
import Loader from '../../../assets/loader'

const Cart = (props) => {
    const [loading, setLoading] = useState(true)

    useEffect(() => {
        const timer = setTimeout(() => {
            setLoading(false)
        }, 2500)

        return () => clearTimeout(timer)
    }, [])

    return (
        <>
            <SEOTAG page="Cart" />
            <Layout props={props}>
                {/* <DashboardHeader /> */}
                {loading ? (
                    <div className="text-center">
                        <Loader />
                    </div>
                ) : (
                    <div className="lq-db-table">
                        <CartComponent props={props} />
                    </div>
                )}
            </Layout>
        </>
    )
}

export default Cart
